import { createAction, props } from '@ngrx/store';
import { INavItem } from '../../../layout/navigation/models/nav-item.model';

export const enum EApplicationActions {
  messageReceived = '[Application] Message Received',
  sendMessage = '[Application] Send Message',
  showLoader = '[Application] Show Loader',
  hideLoader = '[Application] Hide Loader',
  setScreenSize = '[Application] Set Screen Size',
  configureNavigationComplete = '[Application] Configure Navigation Complete',
}

const messageReceived = createAction(EApplicationActions.messageReceived, props<{ message: string }>());
const sendMessage = createAction(EApplicationActions.sendMessage, props<{ message: string | number }>());
const showLoader = createAction(EApplicationActions.showLoader);
const hideLoader = createAction(EApplicationActions.hideLoader);
const configureNavigationComplete = createAction(
  EApplicationActions.configureNavigationComplete,
  props<{ navigation: INavItem[] }>(),
);
const setScreenSize = createAction(EApplicationActions.setScreenSize, props<{ size: number }>());

export const APPLICATION_ACTIONS = {
  messageReceived,
  sendMessage,
  hideLoader,
  showLoader,
  setScreenSize,
  configureNavigationComplete,
};
